import { render, staticRenderFns } from "./GovDashboard.vue?vue&type=template&id=23c1e9e2&scoped=true&"
import script from "./GovDashboard.vue?vue&type=script&lang=js&"
export * from "./GovDashboard.vue?vue&type=script&lang=js&"
import style0 from "./GovDashboard.vue?vue&type=style&index=0&id=23c1e9e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c1e9e2",
  null
  
)

export default component.exports